import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as usersActions from '../store/users/actions';
import * as reducers from '../store/reducers';
import { getNameString } from '../utilities';

import Loading from 'Components/Loading';
import Error from 'Containers/Error';
import BackLink from 'Components/BackLink';
import ContentFrame from 'Components/ContentFrame';
import SectionHeader from 'Components/SectionHeader';

import EditUserForm from 'Containers/EditUserForm';

import PageMessage from 'Components/PageMessage';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from 'Settings/route-strings';

const UserEditWrapper = ({ location, children }) => {
  const backLinkProps = {
    label: <ConnectedFormattedMessage id="user_edit_page.back_link" />,
    route: ROUTES.USERS,
    type: 'content-frame-medium',
  };

  if (location.state && location.state.groupType === 'class') {
    backLinkProps.route = location.state.backTo;
    backLinkProps.label = (
      <ConnectedFormattedMessage id="user_edit_page.class_back_link" />
    );
  }

  return (
    <main className="Page__content">
      <ContentFrame
        size="medium"
        pageType="static-modal"
        backLink={<BackLink {...backLinkProps} />}
      >
        {children}
      </ContentFrame>
    </main>
  );
};

class UserEdit extends React.Component {
  componentDidMount() {
    const {
      match: {
        params: { id },
      },
    } = this.props;
    this.props.fetchUser(id);
  }

  render() {
    const { user, location, error, activeUser } = this.props;

    // If we can’t fetch the user, show the error page.
    if (error) {
      const errorType = (e) => {
        // There is a bug in the API where unknown user IDs return a 500 error.
        // Until that is fixed, we’ll return 404s for any 'impossible occurred'
        // results.
        if (e.errorCode === 31) return 'pageNotFound';
        if (!e.meta || e.meta.status === 500) return 'apiLoadError';
        const { status } = e.meta;
        if (status === 404) return 'pageNotFound';
        if (status >= 401 && status < 404) return 'permissionDenied';
        return 'apiLoadError';
      };
      return <Error type={errorType(error)} code={error.errorCode} />;
    }

    // Lookin for the user...
    if (!user || !activeUser) return <Loading />;

    // Check if the active user is allowed to edit this user.
    if (activeUser.isStudent || (!activeUser.isAdmin && user.isEducator))
      return <Error type="permissionDenied" code="401" />;

    if (user.isDeactivated)
      return (
        <UserEditWrapper {...this.props}>
          <PageMessage
            title={
              <ConnectedFormattedMessage
                id="user_edit_page.deactivated_title"
                values={{ name: getNameString(user) }}
              />
            }
            type="success"
          />
        </UserEditWrapper>
      );

    if (user.isDeactivating)
      return (
        <UserEditWrapper {...this.props}>
          <Loading type="component" />
        </UserEditWrapper>
      );
    return (
      <UserEditWrapper {...this.props}>
        <SectionHeader
          title={
            <ConnectedFormattedMessage
              id="user_edit_page.edit_title"
              values={{
                is_educator: user.isEducator,
              }}
            />
          }
          type="static-modal"
        />
        <EditUserForm user={user} formStyle="editUser" />
      </UserEditWrapper>
    );
  }
}

const mapStateToProps = (state, { match: { params } }) => {
  return {
    user: reducers.getUser(state, params.id),
    activeUser: reducers.getActiveUser(state),
    error: reducers.getUserError(state),
  };
};

export default withRouter(connect(mapStateToProps, usersActions)(UserEdit));
